











































import { Component, Mixins } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";

interface AutorouteTopic {
  id: number;
  title: string;
  url: string;
  is_active: boolean;
  updated_at: string;
}

const DEFAULT_AUTOROUTE_TOPIC: AutorouteTopic = {
  id: 0,
  title: "",
  url: "",
  is_active: false,
  updated_at: "",
};

@Component
export default class Topics extends Mixins(AxiosMixin) {
  private topic: AutorouteTopic = { ...DEFAULT_AUTOROUTE_TOPIC };

  public created(): void {
    this.fetchTopic();
  }

  private fetchTopic(): void {
    this.postJsonCheck(
      window.base_url + "/api/admin/airoute/topic/get",
      {},
      (res) => {
        if (res.data.autoroute_topic) {
          this.topic = res.data.autoroute_topic;
        }
      }
    );
  }

  private async save(): Promise<void> {
    if (!(await this.$openConfirm("保存しますか?"))) {
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/admin/airoute/topic/save",
      { autoroute_topic: this.topic },
      () => {
        this.fetchTopic();
      }
    );
  }
}
